export default function Logo({
  scrolled,
  forceWhite,
  whiteText,
  compact = false,
}) {
  const isWhite = whiteText || (!scrolled && forceWhite);
  const mainColor = isWhite ? '#ffffff' : '#000000';
  const subColor = isWhite ? 'rgba(255,255,255,0.72)' : '#64748b';

  return (
    <div
      className="flex items-center -ml-1 sm:-ml-2"
      aria-label="Bizfund"
      role="img"
    >
      <div className="flex min-w-0 flex-col justify-center">
        <span
          className={`block leading-none tracking-tight ${
            compact ? 'text-[2.2rem] sm:text-[2.4rem]' : 'text-[3.2rem] sm:text-[3.6rem]'
          }`}
          style={{
            color: mainColor,
            fontFamily: 'Nunito, sans-serif',
            fontWeight: 900,
          }}
        >
          bizfund
        </span>

        <span
          className={`block leading-none uppercase ${
            compact ? 'mt-0.5 text-[0.52rem] sm:text-[0.58rem] tracking-[0.18em]' : 'mt-1 text-[0.74rem] sm:text-[0.82rem] tracking-[0.22em]'
          }`}
          style={{
            color: subColor,
            fontWeight: 700,
          }}
        >
          loyal to you and your growth
        </span>
      </div>
    </div>
  );
}
